'use client';

import { Button } from "@/components/ui/button";

export default function ContactSection() {
    return (
        <section className="w-full bg-primary py-12 md:py-20 lg:py-24">
            <div className="container mx-auto px-4 md:px-6 lg:px-8 flex flex-col lg:flex-row items-center justify-between gap-8 text-center lg:text-left flex-wrap">
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#555555] max-w-3xl leading-tight">
                    Sợi Cửu Long, đối tác tin cậy cho tương lai bền vững
                </h2>
                <Button
                    onClick={() => window.open("https://zalo.me/0902855892", "_blank", "noopener,noreferrer")}
                    className="px-8 py-4 text-lg bg-white text-[#555555] hover:bg-gray-100 transition-colors duration-200 shadow-md"
                >
                    LIÊN HỆ VỚI CHÚNG TÔI
                </Button>
            </div>
        </section>
    );
}
